var _filter, _g, _ellipse, _circle, _circle2, _circle3, _circle4, _ellipse2, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg04D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "denseClouds04d",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F8FAFC",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#E2E8F0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#CBD5E1",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "denseCloudsShadow04d"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 4,
    stdDeviation: 3,
    floodColor: "#94A3B8",
    floodOpacity: 0.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFE066",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 25,
    x2: 80,
    y2: 20
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 40,
    rx: 25,
    ry: 15,
    fill: "url(#denseClouds04d)",
    filter: "url(#denseCloudsShadow04d)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 35,
    r: 12,
    fill: "url(#denseClouds04d)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 35,
    r: 14,
    fill: "url(#denseClouds04d)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 30,
    r: 10,
    fill: "url(#denseClouds04d)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 30,
    r: 11,
    fill: "url(#denseClouds04d)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 65,
    rx: 23,
    ry: 14,
    fill: "url(#denseClouds04d)",
    filter: "url(#denseCloudsShadow04d)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 60,
    r: 11,
    fill: "url(#denseClouds04d)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 60,
    r: 13,
    fill: "url(#denseClouds04d)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 55,
    r: 9,
    fill: "url(#denseClouds04d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04D);
export default __webpack_public_path__ + "static/media/04d.8119ab60fb312d649b6ec5215004b0da.svg";
export { ForwardRef as ReactComponent };